import styled from 'styled-components'

export const P = styled.p`
  margin: 1rem 0;
`
P.displayName = 'P'

export const H1 = styled.h1`
  font-weight: bold;
  font-size: 2em;
  margin: 0.67em 0;
`
H1.displayName = 'H1'

export const H2 = styled.h2`
  font-weight: bold;
  font-size: 1.5em;
  margin: 0.83em 0;
`
H2.displayName = 'H2'

export const H3 = styled.h3`
  font-weight: bold;
  font-size: 1.17em;
  margin: 1em 0;
  border-bottom: 0;
`
H3.displayName = 'H3'

export const H4 = styled.h4`
  font-weight: bold;
  margin: 1.33em 0;
`
H4.displayName = 'H4'

export const H5 = styled.h5`
  font-weight: bold;
  margin: 0;
`
H5.displayName = 'H5'

export const Pre = styled.pre`
  background-color: inherit;
  color: inherit;
  padding: initial;
  white-space: pre-wrap;
  font-size: inherit;
`
Pre.displayName = 'Pre'
